import styled from 'styled-components';

import { TextButton } from '@xing-com/button';
import { spaceXXL } from '@xing-com/tokens';

const StyledTextButton = styled(TextButton)`
  margin-top: ${spaceXXL};
`;

export const Styled = {
  TextButton: StyledTextButton,
};
